import { CommentDialog } from '@/components';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { cn } from '@/lib/utils';

import { getRevisionCommentDialogConfig } from './revision-comment-dialog-config';

type Props = {
  showAddRevisionCommentsDialog: boolean;
  setShowAddRevisionCommentsDialog: (show: boolean) => void;
  handleGetValue: (fieldName: string) => string | null;
  handleSetValue: (fieldName: string, value: string) => void;
  disabled?: boolean;
  className?: string;
  isMultiSelectEnabled?: boolean;
  selectedRowCount?: number;
  isBatchPoolRevisionEnabled?: boolean;
};

const RevisionsButton = ({
  showAddRevisionCommentsDialog,
  setShowAddRevisionCommentsDialog,
  handleGetValue,
  handleSetValue,
  disabled,
  className,
  isMultiSelectEnabled = false,
  selectedRowCount = 1,
  isBatchPoolRevisionEnabled = false,
}: Props) => {
  const revisionCommentDialogConfig =
    getRevisionCommentDialogConfig(isMultiSelectEnabled);

  return (
    <>
      <Button
        variant="outline"
        className={cn('gap-1.5', className)}
        onClick={() => setShowAddRevisionCommentsDialog(true)}
        disabled={disabled}
        title="Add Revision Comments. This will add revision comments and appropriate revision number to the selected schedule"
      >
        <i className="pi pi-plus text-xs" />
        Revision Comments
      </Button>
      <Dialog
        open={showAddRevisionCommentsDialog}
        onOpenChange={(open) => {
          if (!open) setShowAddRevisionCommentsDialog(false);
        }}
      >
        <DialogContent className="max-h-[90vh] max-w-[80vw] overflow-y-auto">
          <CommentDialog
            config={revisionCommentDialogConfig}
            setValue={handleSetValue}
            getValue={handleGetValue}
            onClose={() => setShowAddRevisionCommentsDialog(false)}
            allowDelete={
              isBatchPoolRevisionEnabled ? selectedRowCount <= 1 : true
            }
            useImprovedParsing={isBatchPoolRevisionEnabled}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default RevisionsButton;
